namespace appn.views.users.create {

    export function init(): void {
        addEvents();
    }

    function addEvents() {
        // Hook save link
        $('#saveLink').click(function(): void {
            $('form#appnForm').submit();
        });

        $('#btn-genIntegrationKey1').on('click', function(e) {
            e.preventDefault();
            createApiKey(1);
        });
        $('#btn-genIntegrationKey2').on('click', function(e) {
            e.preventDefault();
            createApiKey(2);
        });
    }

    function createApiKey(userApiNumber: number) {
        const $form = $('form#appnForm');
        $form.append('<input type="hidden" name="RegenAPIKey' + userApiNumber + '" value="true" />');
        $('#genKeyInputGroup' + userApiNumber).html('<span class="input-group-sm">' + T('This Key will be generated upon saving this user.') + '</span>');
    }
}

